export const GET_MY_OPEN_ROLES_STARTED = 'GET_POSSIBLE_CAREER_MOVES_STARTED';
export const GET_MY_OPEN_ROLES_SUCCESS = 'GET_POSSIBLE_CAREER_MOVES_SUCCESS';
export const GET_MY_OPEN_ROLES_FAILED = 'GET_POSSIBLE_CAREER_MOVES_FAILED';

export const SET_SELECTED_OPEN_REQUISITION = 'SET_SELECTED_OPEN_REQUISITION';
